module.exports = __webpack_public_path__ + "img/선릉 미용실.cd8b8cd8.png";